module.exports = __webpack_public_path__ + "static/media/14.93ad66bb.png";